module.exports = __webpack_public_path__ + "img/10_l_no.b1925130.svg";